<!--
 * @Author: yuanjianlong
 * @Description: 组件展示
 * @Date: 2021-12-01 11:19:24
 * @LastEditTime: 2021-12-08 15:14:31
 * @FilePath: /teacher-h5/src/demo/checkbox.vue
-->
<template>
  <div class="h-full p-20 bg-gray-10">
    <div>
      <h1 class="text-h32 mb-20">
        Checkbox 多选框
      </h1>
      <div>
        <div class="mb-20">
          <a-checkbox @change="onChange">
            Checkbox
          </a-checkbox>
          <a-checkbox :default-checked="false" disabled>
            Checkbox
          </a-checkbox>
          <a-checkbox default-checked disabled>
            Checkbox
          </a-checkbox>
        </div>
        <div class="mb-20">
          <div :style="{ borderBottom: '1px solid #E9E9E9' }">
            <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
              Check all
            </a-checkbox>
          </div>
          <br />
          <a-checkbox-group v-model="checkedList" :options="plainOptions" @change="onChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const plainOptions = ['Apple', 'Pear', 'Orange']
const defaultCheckedList = ['Apple', 'Orange']
export default {
  data() {
    return {
      checkedList: defaultCheckedList,
      indeterminate: true,
      checkAll: false,
      plainOptions
    }
  },
  methods: {
    onChange(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < plainOptions.length
      this.checkAll = checkedList.length === plainOptions.length
    },
    onCheckAllChange(e) {
      Object.assign(this, {
        checkedList: e.target.checked ? plainOptions : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
    }
  }
}
</script>

<style>
</style>